import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import MainRoutes from 'content/routes/main.routes';
import { ThemeProviderWrapper } from './theme';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import { Authenticator } from '@aws-amplify/ui-react';
import { CssBaseline } from '@mui/material';
import ReactGA from 'react-ga4';
import { AuthProvider, NotificationProvider } from './contexts';

// Google Analytics
if (window.location.host === 'innsights.avanisolutions.co.uk') {
  ReactGA.initialize('G-6D8RT2R1J3');
}

function App() {
  return (
    <ThemeProviderWrapper>
      <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="gb">
        <Authenticator.Provider>
          <NotificationProvider>
            <AuthProvider>
              <CssBaseline />
              <MainRoutes />
            </AuthProvider>
          </NotificationProvider>
        </Authenticator.Provider>
      </LocalizationProvider>
    </ThemeProviderWrapper>
  );
}

export default App;
